import { ChangeDetectionStrategy, Component, inject, input, ViewEncapsulation } from '@angular/core';
import { ButtonComponent, RootDirective, TooltipDirective } from '@pure/hive';
import { Subject } from 'rxjs';
import {
    NvmeNowRenderInfo,
    RECOMMENDATION_ACTION_EVENT_TOKEN,
    RecommendationActionEvent,
} from '../../../../data/models/recommendations.models';
import { registerAsDialogPlugin } from '../../services/recommendation-component-registry.service';

/** Stable registry key for this plugin. Used as the lookup name on the corresponding RenderInfo. */
export const NVME_NOW_DIALOG_PLUGIN_NAME = 'NvmeNowDialogPluginComponent';

/**
 * Dialog component for the NVMe Now (prorec-nvme-now) recommendation.
 *
 * Displayed when the user clicks an NVMe Now recommendation card. The dialog
 * body is a purely data-driven Appliance Details table: every row (label +
 * one-or-more display lines) is pre-computed by `RecommendationProcessingService`
 * and delivered via `renderInfo.detailRows`. The plugin only iterates and
 * routes footer actions (Dismiss / Cancel / Contact Account Team) back to the
 * container via {@link RECOMMENDATION_ACTION_EVENT_TOKEN}.
 */
@Component({
    selector: 'nvme-now-dialog-plugin',
    templateUrl: './nvme-now-dialog-plugin.component.html',
    styleUrls: ['./nvme-now-dialog-plugin.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RootDirective, TooltipDirective],
    encapsulation: ViewEncapsulation.None,
})
export class NvmeNowDialogPluginComponent {
    renderInfo = input.required<NvmeNowRenderInfo>();

    readonly RecommendationActionEvent = RecommendationActionEvent;

    private readonly recommendationActionEvent$ = inject<Subject<RecommendationActionEvent>>(
        RECOMMENDATION_ACTION_EVENT_TOKEN,
        { optional: true },
    );

    handleActionEvent(action: RecommendationActionEvent): void {
        this.recommendationActionEvent$?.next(action);
    }
}

registerAsDialogPlugin(NVME_NOW_DIALOG_PLUGIN_NAME, NvmeNowDialogPluginComponent);
